import moment from 'moment-timezone';

import { AccessControlEnum, DepartmentEnum, IndustryEnum, LanguageEnum } from '../graphql/gen/types';

// we can't just use the enum value and we need a separate value field because value can also be boolean
export type EnumData<T extends string | boolean> = Record<string, { displayName: string; value: T }>;

export const LanguageEnumData: EnumData<string> = {
  [LanguageEnum.En]: {
    displayName: 'English',
    value: LanguageEnum.En,
  },
};

export const TimeZoneEnumData: EnumData<string> = moment.tz.names().reduce(
  (partial: EnumData<string>, timezone: string) => ({
    ...partial,
    [timezone]: { displayName: timezone.replace('_', ' '), value: timezone },
  }),
  {}
);

export const YesNoEnumData: EnumData<boolean> = {
  YES: {
    displayName: 'Yes',
    value: true,
  },
  NO: {
    displayName: 'No',
    value: false,
  },
};

export const IndustryEnumData: EnumData<string> = {
  [IndustryEnum.Technology]: {
    displayName: 'Technology & IT',
    value: IndustryEnum.Technology,
  },
};

export const DepartmentEnumData: EnumData<string> = {
  [DepartmentEnum.Product]: {
    displayName: 'Product',
    value: DepartmentEnum.Product,
  },
  [DepartmentEnum.Sales]: {
    displayName: 'Sales',
    value: DepartmentEnum.Sales,
  },
  [DepartmentEnum.Marketing]: {
    displayName: 'Marketing',
    value: DepartmentEnum.Marketing,
  },
  [DepartmentEnum.CustomerSuccess]: {
    displayName: 'Customer Success',
    value: DepartmentEnum.CustomerSuccess,
  },
  [DepartmentEnum.Engineering]: {
    displayName: 'Engineering',
    value: DepartmentEnum.Engineering,
  },
  [DepartmentEnum.Operations]: {
    displayName: 'Operations',
    value: DepartmentEnum.Operations,
  },
  [DepartmentEnum.Finance]: {
    displayName: 'Finance',
    value: DepartmentEnum.Finance,
  },
  [DepartmentEnum.Legal]: {
    displayName: 'Legal',
    value: DepartmentEnum.Legal,
  },
};

export const AccessControlEnumData: EnumData<string> = {
  [AccessControlEnum.User]: {
    displayName: 'User',
    value: AccessControlEnum.User,
  },
  [AccessControlEnum.DomainAdmin]: {
    displayName: 'Domain Admin',
    value: AccessControlEnum.DomainAdmin,
  },
};
